export class MembershipsChange {
  static type = '[PermissionsState] Membership changed';
}
export class UpdatePermissions {
  userPermissions;
  static type = '[PermissionsState] Permissions updated';
  constructor(userPermissions) {
    this.userPermissions = userPermissions;
  }
}
